import React, { useState, useEffect, useRef } from 'react';
import { gridSpacing } from 'store/constant';
import { styled, useTheme } from '@mui/material/styles';
import { useHistory, useLocation, useNavigate } from 'react-router-dom';
import { Avatar, Button } from '@mui/material';
import { connect, useDispatch } from 'react-redux';
import './styleSearch.scss';
import {
  fetchAdvertiserList,
  setSelectedAdvertiser,
  fetchCampaignsByAdvertiserGuid,
  fetchCampaignsForAdvertiser,
  fetchSkanCampaignsForAdvertiser,
  fetchCTVCampaignsForAdvertiser,
  fetchGTVCampaignsForAdvertiser
} from '../../redux/advertiser/advertiserActions';

import { applyFilter, fetchDashboardDataNonSkan, fetchDashboardDataSkan } from '../../redux/campaign/campaignActions';
import { fetchReportDataForNonSkanReporting, fetchReportDataForSkanReporting } from '../../redux/reporting/reportingActions';
import { fetchCreativeDataNonSkan, fetchCreativeDataSkan } from '../../redux/creative/creativeActions';
import { fetchRawEventSkanData, fetchRawEventNonSkanData } from '../../redux/rawEvent/rawEventActions';
import { fetchStateReportSkanData, fetchStateReportNonSkanData } from '../../redux/stateReport/stateReportActions';
import { fetchWowReportSkanData, fetchWowReportNonSkanData } from '../../redux/wow/wowActions';
import { fetchIAPData } from '../../redux/iap/iapActions';
import { fetchDoDDataNonSkan, fetchDoDDataSkan } from '../../redux/dod/dodActions';
import { fetchD2CData, fetchD2CRequestData } from '../../redux/d2c/d2cActions';
import { fetchCTVData, resetCTVData } from '../../redux/ctv/ctvActions';
import { fetchGTVData, resetGTVData } from '../../redux/gtv/gtvActions';

const ApplyFilterPage = ({
  isSkan,
  selected_campaigns,
  applyFilter,
  applyFilterStatus,
  fetchReportDataForNonSkanReporting,
  fetchReportDataForSkanReporting,
  firstFilter,
  fetchDashboardDataNonSkan,
  fetchDashboardDataSkan,
  fetchCreativeDataNonSkan,
  fetchCreativeDataSkan,
  fetchRawEventSkanData,
  fetchRawEventNonSkanData,
  fetchStateReportSkanData,
  fetchStateReportNonSkanData,
  fetchWowReportSkanData,
  fetchWowReportNonSkanData,
  fetchIAPData,
  fetchDoDDataNonSkan,
  fetchDoDDataSkan,
  sfId,
  startDate,
  endDate,
  wowStartDate, // ADD
  wowEndDate, // ADD
  advertiser_campaign_fetching,
  performanceLoading,
  widzardLoading,
  reportLoading,
  userDashboardPermissions,
  fetchD2CData,
  fetchD2CRequestData
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = location.pathname.split('/')[1];

  const [disableFilterButton, setDisableFilterButton] = useState(false);

  const advertiserGuid = localStorage.getItem('advertiserId');

  // Get Start and End Date
  const getEffectiveDates = () => {
    if (currentPath === 'wow') {
      console.log('Using WoW dates:', { wowStartDate, wowEndDate });
      return {
        startDate: wowStartDate, // for WoW page - Start Date
        endDate: wowEndDate //// for WoW page - End Date
      };
    }
    console.log('Using default dates:', { startDate, endDate });
    return { startDate, endDate }; // for other pages
  };

  // When button clicked fetch campaigns for advertiser
  const applyFilterButton = () => {
    applyFilter(true);

    const { startDate: effectiveStart, endDate: effectiveEnd } = getEffectiveDates();

    console.log('ApplyFilter UTC - About to fetch campaigns with dates:', {
      startDate,
      endDate,
      isSkan,
      sfId
    });

    // Check if user has no permissions (empty arrays = show all data)
    const hasNoPermissions =
      userDashboardPermissions &&
      userDashboardPermissions.tabs &&
      userDashboardPermissions.tabs.length === 0 &&
      userDashboardPermissions.widgets &&
      userDashboardPermissions.widgets.length === 0;

    // Validate date for WoW
    if (!effectiveStart || !effectiveEnd) {
      console.error('❌ WoW Dates not set!');
      if (currentPath === 'wow') {
        alert('Please select at least one quarter before applying filter.');
      }
      return;
    }

    if (hasNoPermissions) {
      console.log('🔍 ApplyFilter UTC - User has no permissions, loading all data directly');
      console.log('🔍 ApplyFilter UTC - Before data loading, loading states:', {
        applyFilterStatus,
        advertiser_campaign_fetching,
        performanceLoading,
        widzardLoading,
        reportLoading
      });

      // If no permissions, load data directly without campaign filtering
      if (currentPath === 'dashboard') {
        isSkan ? fetchDashboardDataSkan(selected_campaigns) : fetchDashboardDataNonSkan(selected_campaigns);
      } else if (currentPath === 'reporting') {
        isSkan ? fetchReportDataForSkanReporting(selected_campaigns) : fetchReportDataForNonSkanReporting(selected_campaigns);
      } else if (currentPath === 'creative') {
        isSkan ? fetchCreativeDataSkan(selected_campaigns) : fetchCreativeDataNonSkan(selected_campaigns);
      } else if (currentPath === 'rawevents') {
        isSkan ? fetchRawEventSkanData(selected_campaigns) : fetchRawEventNonSkanData(selected_campaigns);
      } else if (currentPath === 'statereport') {
        isSkan ? fetchStateReportSkanData(selected_campaigns) : fetchStateReportNonSkanData(selected_campaigns);
      } else if (currentPath === 'wow') {
        isSkan ? fetchWowReportSkanData(selected_campaigns) : fetchWowReportNonSkanData(selected_campaigns);
      } else if (currentPath === 'dod') {
        isSkan ? fetchDoDDataSkan(selected_campaigns) : fetchDoDDataNonSkan(selected_campaigns);
      } else if (currentPath === 'iap') {
        fetchIAPData();
      } else if (currentPath === 'ctv') {
        dispatch(resetCTVData());
        dispatch(fetchCTVData(startDate, endDate, selected_campaigns));
      } else if (currentPath === 'gtv') {
        dispatch(resetGTVData());
        dispatch(fetchGTVData(startDate, endDate, selected_campaigns));
      }

      console.log('🔍 ApplyFilter UTC - Data loading initiated, will reset applyFilter when data loads');
      // Don't reset applyFilter immediately - let the data loading success handlers do it
      return;
    }

    // Campaign Fetch condition
    const shouldFetchCampaigns = !selected_campaigns || selected_campaigns.length === 0;

    // Normal flow: fetch campaigns first when none selected
    if (shouldFetchCampaigns && advertiserGuid && effectiveStart && effectiveEnd) {
      console.log('ApplyFilter UTC - Calling campaign fetch function with dates:', {
        effectiveStart,
        effectiveEnd
      });
      if (currentPath === 'ctv') {
        dispatch(fetchCTVCampaignsForAdvertiser(advertiserGuid, sfId, effectiveStart, effectiveEnd));
      } else if (currentPath === 'gtv') {
        dispatch(fetchGTVCampaignsForAdvertiser(advertiserGuid, sfId, effectiveStart, effectiveEnd));
      } else if (isSkan) {
        dispatch(fetchSkanCampaignsForAdvertiser(advertiserGuid, sfId, effectiveStart, effectiveEnd));
      } else {
        dispatch(fetchCampaignsForAdvertiser(advertiserGuid, sfId, effectiveStart, effectiveEnd));
      }
    } else if (shouldFetchCampaigns) {
      // Only warn when we needed to fetch campaigns but something was missing
      console.warn('Missing advertiserGuid/startDate/endDate:', {
        advertiserGuid,
        startDate,
        endDate
      });
    }
  };

  // When campaigns update in Redux trigger data fetch
  useEffect(() => {
    if (applyFilterStatus) {
      console.log('Apply UTC Filter triggered for path:', currentPath, 'campaigns:', selected_campaigns.length);

      if (currentPath === 'dashboard') {
        isSkan ? fetchDashboardDataSkan(selected_campaigns) : fetchDashboardDataNonSkan(selected_campaigns);
      } else if (currentPath === 'reporting') {
        isSkan ? fetchReportDataForSkanReporting(selected_campaigns) : fetchReportDataForNonSkanReporting(selected_campaigns);
      } else if (currentPath === 'creative') {
        isSkan ? fetchCreativeDataSkan(selected_campaigns) : fetchCreativeDataNonSkan(selected_campaigns);
      } else if (currentPath === 'rawevents') {
        isSkan ? fetchRawEventSkanData(selected_campaigns) : fetchRawEventNonSkanData(selected_campaigns);
      } else if (currentPath === 'statereport') {
        isSkan ? fetchStateReportSkanData(selected_campaigns) : fetchStateReportNonSkanData(selected_campaigns);
      } else if (currentPath === 'wow') {
        isSkan ? fetchWowReportSkanData(selected_campaigns) : fetchWowReportNonSkanData(selected_campaigns);
      } else if (currentPath === 'dod') {
        isSkan ? fetchDoDDataSkan(selected_campaigns) : fetchDoDDataNonSkan(selected_campaigns);
      } else if (currentPath === 'iap') {
        fetchIAPData();
      } else if (currentPath === 'd2c') {
        isSkan ? fetchD2CRequestData() : fetchD2CData();
      } else if (currentPath === 'ctv') {
        dispatch(resetCTVData());
        dispatch(fetchCTVData(startDate, endDate, selected_campaigns));
      } else if (currentPath === 'gtv') {
        dispatch(resetGTVData());
        dispatch(fetchGTVData(startDate, endDate, selected_campaigns));
      }

      // reset applyFilter flag after fetch
      applyFilter(false);
    }
  }, [applyFilterStatus, selected_campaigns, currentPath, isSkan]);

  // Disable button when loading
  useEffect(() => {
    const isLoading = applyFilterStatus || advertiser_campaign_fetching || performanceLoading || widzardLoading || reportLoading;
    console.log('🔍 ApplyFilter UTC - Loading states:', {
      applyFilterStatus,
      advertiser_campaign_fetching,
      performanceLoading,
      widzardLoading,
      reportLoading,
      isLoading,
      disableFilterButton
    });
    setDisableFilterButton(isLoading);
  }, [applyFilterStatus, advertiser_campaign_fetching, performanceLoading, widzardLoading, reportLoading]);

  return (
    <div className="filter-Button">
      <Button variant="outlined" onClick={applyFilterButton} disabled={disableFilterButton}>
        Apply Filter
      </Button>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    selected_campaigns: state.advertiserReducer.selected_campaigns,
    advertiser_campaign_fetching: state.advertiserReducer.advertiser_campaign_fetching,
    performanceLoading: state.campaignReducer.performanceLoading,
    widzardLoading: state.campaignReducer.widzardLoading,
    reportLoading: state.campaignReducer.reportLoading,
    isSkan: state.campaignReducer.isSkan,
    applyFilterStatus: state.campaignReducer.applyFilter,
    firstFilter: state.campaignReducer.firstFilter,
    sfId: state.advertiserReducer.sfId,
    startDate: state.campaignReducer.start_date,
    endDate: state.campaignReducer.end_date,
    wowStartDate: state.wowReducer.wow_start_date,
    wowEndDate: state.wowReducer.wow_end_date
  };
};

const mapDispatchToProps = {
  setSelectedAdvertiser: setSelectedAdvertiser,
  fetchCampaignsByAdvertiserGuid: fetchCampaignsByAdvertiserGuid,
  fetchCampaignsForAdvertiser: fetchCampaignsForAdvertiser,
  fetchSkanCampaignsForAdvertiser: fetchSkanCampaignsForAdvertiser,
  applyFilter: applyFilter,
  fetchReportDataForNonSkanReporting: fetchReportDataForNonSkanReporting,
  fetchReportDataForSkanReporting: fetchReportDataForSkanReporting,
  fetchDashboardDataNonSkan: fetchDashboardDataNonSkan,
  fetchDashboardDataSkan: fetchDashboardDataSkan,
  fetchCreativeDataNonSkan: fetchCreativeDataNonSkan,
  fetchCreativeDataSkan: fetchCreativeDataSkan,
  fetchRawEventSkanData: fetchRawEventSkanData,
  fetchRawEventNonSkanData: fetchRawEventNonSkanData,
  fetchStateReportSkanData: fetchStateReportSkanData,
  fetchStateReportNonSkanData: fetchStateReportNonSkanData,
  fetchWowReportSkanData: fetchWowReportSkanData,
  fetchWowReportNonSkanData: fetchWowReportNonSkanData,
  fetchDoDDataSkan: fetchDoDDataSkan,
  fetchDoDDataNonSkan: fetchDoDDataNonSkan,
  fetchIAPData: fetchIAPData,
  fetchD2CData: fetchD2CData,
  fetchD2CRequestData: fetchD2CRequestData
};

export default connect(mapStateToProps, mapDispatchToProps)(ApplyFilterPage);
